var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlipToFront = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1999 2.40039H9.5747C8.2559 2.40039 7.1999 3.45639 7.1999 4.77639V14.4004C7.1999 15.7204 8.2799 16.8004 9.5999 16.8004H19.1999C20.5199 16.8004 21.5999 15.7204 21.5999 14.4004V4.80039C21.5999 3.48039 20.5199 2.40039 19.1999 2.40039ZM19.1999 14.4004H9.5999V4.80039H19.1999V14.4004ZM4.7999 12.0004H2.3999V19.2004C2.3999 20.5204 3.4799 21.6004 4.7999 21.6004H11.9999V19.2004H4.7999V12.0004Z",
    fill: "#1D1F20"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlipToFront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FlipToFront.3bcf1dadddbcab351de204936995c92f.svg";